import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import loc from 'sources/locale/loc';
import InfoCarouselItem from './InfoCarouselItem';
import styles from './InfoCarousel.scss';

export default function InfoCarousel(props) {
  const { current, className, onSwipe } = props;

  return (
    <div className={classnames(styles.container, className)}>
      <button className={styles.swipeButton} onClick={onSwipe}>
        <div className={styles.divider} />
      </button>
      <InfoCarouselItem
        className={classnames(styles.info, { [styles.visible]: current === 0 })}
        position={0}
        text={loc('home-phrase-first')}
      />
      <InfoCarouselItem
        className={classnames(styles.info, { [styles.visible]: current === 1 })}
        position={1}
        text={loc('home-phrase-second')}
      />
      <InfoCarouselItem
        className={classnames(styles.info, { [styles.visible]: current === 2 })}
        position={2}
        text={loc('home-phrase-third')}
      />
      <InfoCarouselItem
        className={classnames(styles.info, { [styles.visible]: current === 3 })}
        position={3}
        text={loc('home-phrase-fourth')}
      />
    </div>
  );
}

InfoCarousel.propTypes = {
  current: PropTypes.number,
};

InfoCarousel.defaultProps = {
  current: 0,
};



// WEBPACK FOOTER //
// ./src/components/IndexPage/InfoCarousel.jsx